

export const checkEdit = (account) => {
    if (account?.roleAll) {
        return true
    } else {
        let res1 = account.roleList?.filter(it => it.module === "account");
        return res1?.length > 0 && res1[0]?.roleCreate
    }
}

export const checkViewAccount = (account) => {
    if (account?.roleAll) {
        return true
    } else {
        let res1 = account.roleList?.filter(it => it.module === "account");
        return res1?.length > 0 && res1[0]?.roleView
    }
}

export const checkViewWeighingStation = (account, code) => {
    if (account?.roleAll) {
        return true
    } else {
        let res1 = account.roleList?.filter(it => it.module === code);
        return res1?.length > 0 && res1[0]?.roleView
    }
}

export const arrayPathAdmin = [
    "overview-seller" , "weighing-station" , "business-commissions" , "download" , "customer"
]

export const arrayPathAdminUser = [
    "overview-weighing-station" , "account" , "subscription-package"
]
export const checkPermission = ( account, paths2) => {

    if (account?.role === "admin" && arrayPathAdmin.includes(paths2) ){
        return true
    }

    return (account?.role === "adminUser" && arrayPathAdminUser.includes(paths2))
}

export const checkWeighingStation = ( weighingStation, paths2 , paths3) => {
    return paths2 === "report-weighing-station" && paths3 &&
        weighingStation.some((item) => item.weighingStationCode === paths3)
}
export const checkEditWeightSlip = (account, code) => {
    if (account?.roleAll) {
        return true
    } else {
        let res1 = account.roleList?.filter(it => it.module === code);
        return res1?.length > 0 && res1[0]?.roleCreate
    }
}
